module.exports = __webpack_public_path__ + "static/media/www.vanhaylioppilastalo.fi.196daa83.png";